/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate a credit-weighted GPA on the 4.0 scale.`)
};

const es_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula un promedio académico ponderado por créditos en la escala de 4.0.`)
};

const de_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne einen kreditgewichteten Notendurchschnitt (GPA) auf der 4,0-Skala.`)
};

const nl_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken een naar studiepunten gewogen GPA op de schaal van 4,0.`)
};

const fr_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez une moyenne pondérée par crédits sur l'échelle de 4,0.`)
};

const it_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola una media voti ponderata sui crediti nella scala 4.0.`)
};

const pt_br2_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule um GPA ponderado por créditos na escala de 4,0.`)
};

const pt_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule uma média ponderada por créditos na escala de 4,0.`)
};

const ja_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.0スケールで単位加重GPAを計算します。`)
};

const zh_gpa_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算基于学分加权的 4.0 制 GPA。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_tool_description", locale)
	if (locale === "en") return en_gpa_tool_description(inputs)
	if (locale === "es") return es_gpa_tool_description(inputs)
	if (locale === "de") return de_gpa_tool_description(inputs)
	if (locale === "nl") return nl_gpa_tool_description(inputs)
	if (locale === "fr") return fr_gpa_tool_description(inputs)
	if (locale === "it") return it_gpa_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_tool_description(inputs)
	if (locale === "pt") return pt_gpa_tool_description(inputs)
	if (locale === "ja") return ja_gpa_tool_description(inputs)
	return zh_gpa_tool_description(inputs)
};